import React from 'react';
const BluetoothContext = React.createContext(null);
export default BluetoothContext;